import React, { useCallback, useEffect, useRef, useState } from "react";
import AddNoteCard from "./AddNoteCard";
import NoteCard from "./NoteCard";

function NoteSection({
  sectionLabel,
  notes,
  showAddCard = false,
  layout = "carousel",
  onAddNote,
  onOpenNote,
  onEditNote,
  onDeleteNote,
}) {
  const scrollRef = useRef(null);
  const [canScroll, setCanScroll] = useState(false);

  const checkOverflow = useCallback(() => {
    const el = scrollRef.current;
    if (el) {
      setCanScroll(el.scrollWidth > el.clientWidth);
    }
  }, []);

  useEffect(() => {
    checkOverflow();
    window.addEventListener("resize", checkOverflow);
    return () => window.removeEventListener("resize", checkOverflow);
  }, [checkOverflow, notes]);

  const scrollForward = () => {
    scrollRef.current?.scrollBy({ left: 280, behavior: "smooth" });
  };

  return (
    <section className="my-notes-section">
      <h2 className="my-notes-section-title">{sectionLabel}</h2>

      <div className={`my-notes-section-row ${layout === "carousel" ? "is-carousel" : ""}`}>
        <div
          ref={scrollRef}
          className={`my-notes-section-cards ${layout === "carousel" ? "is-scrollable" : "is-grid"}`}
        >
          {showAddCard ? <AddNoteCard onClick={onAddNote} /> : null}
          {notes.map((note) => (
            <NoteCard
              key={note.id}
              note={note}
              onOpen={onOpenNote}
              onEdit={onEditNote}
              onDelete={onDeleteNote}
            />
          ))}
        </div>

        {canScroll ? (
          <button
            type="button"
            className="my-notes-scroll-button"
            aria-label={`Scroll ${sectionLabel} notes`}
            onClick={scrollForward}
          >
            ›
          </button>
        ) : null}
      </div>
    </section>
  );
}

export default NoteSection;
